module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-logo004.44369cea.png";